module.exports = __webpack_public_path__ + "static/media/pepper.c6244637.png";